import { HomeContentView } from "components/materials/home/HomeContentView";

/**
 * Participant home personas (`/home/instructor`, `/home/student`, `/home/section_assistant`).
 * Admin is a static sibling route (`admin.tsx`). Views read the role via `useHomeRole`.
 */
export default function Page() {
  return <HomeContentView />;
}
